import firebase from "./FirebaseConfig";

// after using any fetch function, receive data by using:
// .on(
//   "value",
//   (resp) => {
//     setState(snapshotToArray(resp));
//   }
// );

// specific properties are being send in changed form, for example:
// if you want to delete one or more users from chatUsers list, send whole list without id/id`s you want to delete
export const updateData = (key, value) => {
   const normalizedRef = "users";
   return firebase.database().ref(`${normalizedRef}/${key}`).update({
      status: value,
   });
};

// EXAMPLE: reference - "rooms/", key - chat id, value - "new user's list"
export const updateUserInRoomList = (reference, key, value) => {
   const normalizedRef = (reference || "").replace(/^\/+|\/+$/g, "");
   return firebase.database().ref(`${normalizedRef}/${key}`).update({
      chatUsers: value,
   });
};

export const updateNewMessage = (key, value) => {
   const normalizedRef = "users";
   return firebase.database().ref(`${normalizedRef}/${key}`).update({
      newMessage: value,
   });
};

export const updateUserOldId = (reference, key, value) => {
   const normalizedRef = (reference || "").replace(/^\/+|\/+$/g, "");
   return firebase.database().ref(`${normalizedRef}/${key}`).update({
      oldId: value,
   });
};

export const updateNotificationList = (reference, key, value) => {
   const normalizedRef = (reference || "").replace(/^\/+|\/+$/g, "");
   return firebase.database().ref(`${normalizedRef}/${key}`).update({
      seenBy: value,
   });
};

export const updateRoomName = (reference, id, value) => {
   const normalizedRef = (reference || "").replace(/^\/+|\/+$/g, "");
   return firebase.database().ref(`${normalizedRef}/${id}`).update({
      title: value,
   });
};

export const fetchFirebaseBy = (reference, orderBy, equalTo) => {
   return firebase.database().ref(reference).orderByChild(orderBy).equalTo(equalTo);
};

export const fetchFirebase = (reference) => {
   return firebase.database().ref(reference);
};

export const pushFirebase = (reference) => {
   return firebase.database().ref(reference).push();
};

export const deleteRoom = (reference, id) => {
   const normalizedRef = (reference || "").replace(/^\/+|\/+$/g, "");
   return firebase.database().ref(`${normalizedRef}/${id}`).remove();
};

export const changeRoomStatus = async (reference, key, status) => {
   try {
      // exclude cases when there are more than one "/"
      const normalizedRef = (reference || "").replace(/^\/+|\/+$/g, "");
      await firebase.database().ref(`${normalizedRef}/${key}`).update({
         status,
      });
   } catch (error) {
      console.error("Error updating room status:", error);
   }
};

export const changeAssistantStatus = (reference, roomId, status) => {
   const normalizedRef = (reference || "").replace(/^\/+|\/+$/g, "");
   return firebase.database().ref(`${normalizedRef}/${roomId}`).update({ isAsistantBusy: status });
};

export const changeMessageContent = (reference, key, messageContent) => {
   const normalizedRef = (reference || "").replace(/^\/+|\/+$/g, "");
   return firebase.database().ref(`${normalizedRef}/${key}`).update({ content: messageContent });
};
